import { useTranslation } from "@ferrivia/i18n";
import { Sheet, SheetContent, SheetTitle, Text } from "@ferrivia/ui";
import { useAppContext } from "../../../app/useAppContext";
import { useDismissOnBack } from "../../../hooks/useDismissOnBack";
import s from "./LabSourcesSheet.module.css";

const LAB_SOURCES = [
  { name: "Quest Diagnostics", url: "https://www.questhealth.com" },
  { name: "Marek Diagnostics", url: "https://marekhealth.com" },
] as const;

/** US only: where a pilot client can order labs themselves. A plain list, the
    same for every client — we sell no labs in the US and take no part in the
    order. */
export function LabSourcesSheet({ open, onOpenChange }: { open: boolean; onOpenChange: (open: boolean) => void }) {
  const { t } = useTranslation("client");
  const { rootElement } = useAppContext();

  useDismissOnBack(open, () => onOpenChange(false), "labSources");

  return (
    <Sheet open={open} onOpenChange={onOpenChange}>
      <SheetContent container={rootElement} aria-describedby={undefined}>
        <SheetTitle>{t("support.labSources.title", "Mistä saan verikokeet?")}</SheetTitle>
        <Text as="p" size="sm" className={s.body}>
          {t(
            "support.labSources.body",
            "Nämä laboratoriot tarjoavat verikokeita koko maassa. Voit tilata kokeet suoraan niiltä ja lisätä tulokset tänne.",
          )}
        </Text>
        <ul className={s.list}>
          {LAB_SOURCES.map((source) => (
            <li key={source.name}>
              <a className={s.link} href={source.url} target="_blank" rel="noreferrer">
                {source.name}
              </a>
            </li>
          ))}
        </ul>
        <Text as="p" size="xs" className={s.disclaimer}>
          {t(
            "support.labSources.disclaimer",
            "Ferrivia ei ole yhteistyössä näiden yritysten kanssa eikä saa korvausta suosituksista.",
          )}
        </Text>
      </SheetContent>
    </Sheet>
  );
}
